import { auditReports } from '@mi-front/api-clients';
import { useRouter } from '@mi-front/core';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { Button } from '@mui/material';
import { useIntl } from 'react-intl';
import { AodRunsChipNavigation } from '../../../components/AodRunsChipNavigation';
import { aodRoutes } from '../../../routing/routes';
import { PastRunsContent } from './PastRunsContent';
import { ScheduledRunsContent } from './ScheduledRunsContent';

interface AodRuleRunsTabProps {
  rule: auditReports.AodRule;
}

export function AodRuleRunsTab({ rule }: AodRuleRunsTabProps) {
  const { formatMessage } = useIntl();
  const { history } = useRouter();

  const manualRunButton = (
    <Button
      variant="outlined"
      color="warning"
      size="small"
      startIcon={<PlayArrowIcon />}
      onClick={() => history.push(aodRoutes.ruleManualRun.gen(rule.id))}
    >
      {formatMessage({
        id: 'audit.aod.rules.view.runs.triggerManual',
        defaultMessage: 'Ejecutar manualmente',
      })}
    </Button>
  );

  return (
    <AodRunsChipNavigation
      pastRunsContent={<PastRunsContent rule={rule} />}
      scheduledRunsContent={<ScheduledRunsContent rule={rule} />}
      navigationParam="runsTab"
    />
  );
}
